import routes from '@/modules/application-type/application-type-routes';
import store from '@/modules/application-type/application-type-store';

export default {
    routes,
    store,
}
